import { useFormListValidator } from 'core';
import { Stack, Text, Textarea } from 'ui';
import { useForm } from 'ui/Form';

export type FundraisingDescriptionFormType = {
  description?: string;
};

const FundraisingDescriptionForm = ({ initialValue }: { initialValue?: string }) => {
  const form = useForm<FundraisingDescriptionFormType>({
    initialValues: {
      description: initialValue,
    },
  });

  useFormListValidator({ form, id: 'fundraisingDescription' });
  return (
    <Stack gap="lg">
      <Text fz="sm">Let donors know what you're raising money for and why it matters to you.</Text>
      <Textarea
        label="Describe your fundraising effort"
        placeholder="Enter a description of this campaign"
        autosize
        minRows={6}
        maxRows={6}
        {...form.getInputProps('description')}
      />
    </Stack>
  );
};

export { FundraisingDescriptionForm };
